import { Routes, Route, Navigate } from 'react-router-dom'
import SuperAdminOnboardingProvider from './context/SuperAdminOnboardingContext'
import OnboardingLiftOff from 'pages/onboarding-lift-off/view/OnboardingLiftOff'

import StepOne from './view/SuperAdminOnboarding/StepOne'
import StepTwo from './view/SuperAdminOnboarding/StepTwo'
import StepThree from './view/SuperAdminOnboarding/StepThree'
import StepFour from './view/SuperAdminOnboarding/StepFour'

const SuperAdminRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="step-1" />} />
      <Route path="/" element={<SuperAdminOnboardingProvider />}>
        <Route path="/step-1" element={<StepOne />} />
        <Route path="/step-2" element={<StepTwo />} />
        <Route path="/step-3" element={<StepThree />} />
        <Route path="/step-4" element={<StepFour />} />
        <Route path="/step-5" element={<OnboardingLiftOff />} />
      </Route>
    </Routes>
  )
}

export default SuperAdminRoutes
